export default __webpack_public_path__ + "static/media/Helvetica Neue LT 75 Bold.ee6f0e0e.ttf";